import { Big as o } from "big.js";
import { checkChainSupport as c, sellTokenHODLRewarderAddressEnum as w, sellTokenHODLRewarderAddress as m, uHODLRewarderAddressEnum as g, uHODLRewarderAddress as v, DOBStakingPoolAddressEnum as k, DOBStakingPoolAddress as O, StakingPoolsAddressEnum as A, StakingPoolsAddress as F, StakingPoolRewarderAddressEnum as R, StakingPoolRewarderAddress as x, HODLStakingPoolsAddressEnum as S, HODLStakingPoolsAddress as $, HODLStakingPoolRewarderAddressEnum as C, HODLStakingPoolRewarderAddress as D, MatchingMarketAddressEnum as h, MatchingMarketAddress as T } from "@deorderbook/contracts";
import { initWalletStore as E, wallet as p } from "../store/index.mjs";
import { setupSubgraph as H } from "../store/subgraph.mjs";
import { getFeeRatio as P } from "../subgraph-api.mjs";
import { getTokenDecimals as L, getTokens as b } from "./token.mjs";
import * as De from "./token.mjs";
import { changeDOBRate as Or, getToken as Ar, getTokenBySymbol as Fr } from "./token.mjs";
import { isUHodlOrSellTokenHODL as _ } from "../util/type.mjs";
import { allowance as M, approve as W } from "./bullet.mjs";
import * as Ee from "./bullet.mjs";
import { entryFeeRatio as B, withdrawFeeRatio as U, exerciseFeeRatio as N, redeemFeeRatio as V, bulletToRewardRatio as j } from "./distributions.mjs";
import * as Pe from "./distributions.mjs";
import { balanceOf as X, allowance as q, approve as z } from "./dob.mjs";
import * as be from "./dob.mjs";
import { getApproved as G, isApprovedForAll as J, approve as K, setApprovedForAll as Q } from "./gold_gerege.mjs";
import * as Me from "./gold_gerege.mjs";
import { balanceOf as Y, allowance as Z, approve as y } from "./hodl.mjs";
import * as Be from "./hodl.mjs";
import { getApproved as I, isApprovedForAll as ee, approve as re, setApprovedForAll as te } from "./silver_gerege.mjs";
import * as Ne from "./silver_gerege.mjs";
import { allowance as oe, approve as ae } from "./sniper.mjs";
import * as je from "./sniper.mjs";
import { allowance as ie, approve as ne } from "./token_erc20.mjs";
import * as qe from "./token_erc20.mjs";
import { balanceOf as le, allowance as se, approve as pe } from "./token_usdc.mjs";
import * as Ge from "./token_usdc.mjs";
import { balanceOf as ue, allowance as fe, approve as de } from "./token_sell_token.mjs";
import * as Ke from "./token_sell_token.mjs";
import { balanceOf as ce, allowance as we, approve as me } from "./token_weth.mjs";
import * as Ye from "./token_weth.mjs";
import { setProvider as ge, chainId as ve, initSigner as ke } from "../store/provider.mjs";
import { ERROR_CONNECT_WALLET as Oe } from "./errors.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "dayjs";
o.PE = 50;
const u = o(2).pow(256).minus(1).toFixed();
let f;
const Ae = {
  debug: !1,
  subgraphOptions: {
    version: "default"
  }
};
function tr(r, e = Ae) {
  c(r.network) && (f = r, ge(f, e.debug), H(ve, e.subgraphOptions));
}
let l, d;
function or(r) {
  l = r;
}
function ar(r) {
  d = r;
}
async function ir(r) {
  const e = E(r);
  return e.isSupported() ? (e.setOnAccountChangedCallback((t) => {
    l?.(t);
  }), e.setOnChainChangedCallback((t) => {
    l != null && d(t);
  }), await e.connect(), await ke(), e?.isConnected() ? 1 : 0) : -1;
}
function nr(r) {
  if (p === void 0) throw Oe;
  return p.addToken(r).then((e) => e);
}
async function lr(r, e) {
  return r === "DOB" ? await X(e) : r === "USDC" ? await le(e) : r === "sellToken" ? await ue(e) : r === "WETH" ? await ce(e) : await Y(r, e);
}
async function sr(r, e, t, a) {
  if (r.startsWith("0x")) {
    if (a === "sniperContracts")
      return await oe(r, e, t);
    if (a === "bulletContracts")
      return await M(r, e, t);
    if (a === "erc20Contracts")
      return await ie(r, e, t);
    throw new Error("Missing parameter: contracts");
  }
  if (r === "DOB")
    return await q(e, t);
  if (r === "USDC")
    return await se(e, t);
  if (r === "sellToken")
    return await fe(e, t);
  if (r === "WETH")
    return await we(e, t);
  if (["uHODL", "sellTokenHODL"].includes(r))
    return await Z(r, e, t);
  throw new Error("Invalid value");
}
function pr(r, e) {
  return r === "silver" ? I(e) : G(e);
}
function ur(r, e, t) {
  return r === "silver" ? ee(e, t) : J(e, t);
}
async function fr(r, e, t, a) {
  if (r.startsWith("0x")) {
    const s = u;
    if (t === "sniperContracts")
      return await ae(r, e, s);
    if (t === "bulletContracts")
      return await W(r, e, s);
    if (t === "erc20Contracts")
      return await ne(r, e, s);
    throw new Error("Missing parameter: contracts");
  }
  if (L(
    r
  ) === void 0) throw new Error("Missing decimals");
  const i = a ?? u;
  if (r === "DOB")
    return await z(e, o(i).toFixed());
  if (r === "USDC")
    return await pe(e, o(i).toFixed());
  if (r === "sellToken")
    return await de(e, o(i).toFixed());
  if (_(r))
    return await y(r, e, o(i).toFixed());
  if (r === "WETH")
    return await me(e, o(i).toFixed());
  throw new Error("Invalid value");
}
async function dr(r, e, t) {
  return r === "silver" ? await re(e, t) : await K(e, t);
}
function cr(r, e, t) {
  return r === "silver" ? te(e, t) : Q(e, t);
}
async function wr() {
  return await P().then((r) => ({
    withdrawFeeRatio: o(r.withdrawFeeRatio ?? "0").div(100).toFixed(),
    // fee when unlocking hodl
    hodlWithdrawFeeRatio: o(r.hodlWithdrawFeeRatio ?? "0").div(100).toFixed(),
    // hodl Redeem
    exerciseFeeRatio: o(r.exerciseFeeRatio ?? "0").div(100).toFixed()
  }));
}
async function mr() {
  const [
    r,
    e,
    t,
    a,
    n
  ] = await Promise.all([
    B(),
    U(),
    N(),
    V(),
    j()
  ]);
  return {
    entryFee: o(r.toString() ?? "0").div(1e4).toFixed(),
    withdrawFee: o(e.toString() ?? "0").div(1e4).toFixed(),
    exerciseFee: o(t.toString() ?? "0").div(1e4).toFixed(),
    redeemFee: o(a.toString() ?? "0").div(1e4).toFixed(),
    bulletToReward: o(n.toString() ?? "0").toFixed()
    // uint8
  };
}
function gr(r, e) {
  const t = {
    sellTokenHODLRewarder: e !== void 0 ? w[e] : m,
    uHODLRewarder: e !== void 0 ? g[e] : v,
    DOBStakingPool: e !== void 0 ? k[e] : O,
    StakingPool: e !== void 0 ? A[e] : F,
    StakingPoolRewarder: e !== void 0 ? R[e] : x,
    HODLStakingPool: e !== void 0 ? S[e] : $,
    HODLStakingPoolRewarder: e !== void 0 ? C[e] : D,
    MatchingMarket: e !== void 0 ? h[e] : T
  };
  return Object.keys(t).includes(r) ? t[r] : b(e).find((n) => n.symbol === r).address;
}
export {
  u as MAX_UINT_256,
  nr as addToken,
  sr as allowance,
  fr as approve,
  lr as balanceOf,
  Ee as bullet,
  Or as changeDOBRate,
  ir as connectWallet,
  Pe as distributions,
  be as dob,
  dr as geregeApprove,
  pr as geregeApproved,
  ur as geregeIsApprovedForAll,
  cr as geregeSetApprovedForAll,
  mr as getAllDistributionFee,
  wr as getAllFeeRatio,
  gr as getContractAddress,
  Ar as getToken,
  Fr as getTokenBySymbol,
  b as getTokens,
  Me as gold_gerege,
  Be as hodl,
  f as options,
  or as setOnAccountChangedCallback,
  ar as setOnChainChangedCallback,
  tr as setOptions,
  Ne as silver_gerege,
  je as sniper,
  De as token,
  qe as token_erc20,
  Ke as token_sell_token,
  Ge as token_usdc,
  Ye as token_weth
};
//# sourceMappingURL=index.mjs.map
